
<div class="loading-message">{{message}}</div>

<mat-spinner></mat-spinner>
